import React from 'react'
import Faq from './Faq'
import Headings from './Headings'

const FaqQuestions =  () => {
  return (
    <div className='py-[80px]'>
        <Headings
           headings='Frequently Asked Questions'
        />
        
        <Faq
         Ques ="What is Virat india Micro finance?"
         ans = "VIRAT INDIA MICRO FINANCE is a Non-Profit company and was incorporated on Nov 21, 2014 in India. It is registered at Registrar of Companies, ROC Kanpur. Its registered address is MAHUAWA,PAKRI TOLA P.O-MAHUAWA BUZURG, Kushinagar, KUSINAGAR, Uttar Pradesh, India, 274302."
        />
        <Faq
         Ques ="What are the requirements to get a loan?"
         ans = {`(i) Must be above 21 years and below 55 years of age

      (ii) Salaried individuals with a minimum salary of ₹25,000 (Metro Cities) and ₹20,000 (Non-metros)

      (iii) Must be a resident of India`}
        />
        
<Faq
 Ques ="What information and documents are required to apply a loan?"
 ans = {`(i) Aadhar Card

(ii) PAN Card

(iii) Last 6 months bank statement`}
        />
        <Faq
         Ques ="Why Virat India Micro Finance is better than other Banks/NBFCs ?"
         ans = {`(i) Instant Cash Loan That Fits All Your Needs.

(ii) Flexible Loan Amount.

(iii) Fully Digital Journey.

(iv) Quick and Secure.

(v) No prepayment charges.`}
        />

    </div>
  )
}

export default FaqQuestions